









































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MonthTotalDataItem } from "@/classes/DistroDataSet";

/* eslint-disable @typescript-eslint/camelcase */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
/* eslint-enable @typescript-eslint/camelcase */

am4core.useTheme(am4themes_material);
// am4core.useTheme(am4themes_animated);

@Component
export default class TotalsChart extends Vue {
  @Prop() chartData!: MonthTotalDataItem[];
  @Prop() public datesFilter!: Date[];

  get totalEarnings(): number {
    let result = 0;
    this.chartData.forEach(t => {
      result += t.earningsUSD;
    });
    return result;
  }
  get totalQuantity(): number {
    let result = 0;
    this.chartData.forEach(t => {
      result += t.quantity;
    });
    return result;
  }

  chart?: am4charts.XYChart;

  mounted() {
    this.renderChart();
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  @Watch("chartData")
  renderChart() {
    if (this.chart) {
      this.chart.dispose();
    }
    this.chart = am4core.create(
      this.$refs.totalsChart as HTMLDivElement,
      am4charts.XYChart
    );

    this.chart.data = this.$props.chartData;

    const xAxes1 = this.chart.xAxes.push(new am4charts.DateAxis());
    xAxes1.dataFields.date = "month";
    xAxes1.cursorTooltipEnabled = false;

    if (this.$props.datesFilter && this.$props.datesFilter.length > 1) {
      xAxes1.min = new Date(this.$props.datesFilter[0]).getTime();
      xAxes1.max = new Date(this.$props.datesFilter[1]).getTime();
    }

    xAxes1.baseInterval = { timeUnit: "month", count: 1 };
    xAxes1.periodChangeDateFormats.setKey("day", "MMM");
    xAxes1.dateFormats.setKey("day", "MMM");

    xAxes1.renderer.grid.template.location = 0;

    xAxes1.renderer.minGridDistance = 50;

    const axis1 = this.chart.yAxes.push(new am4charts.ValueAxis());
    axis1.id = "axis1";
    axis1.title.text = "Earnings (USD)";
    axis1.min = 0;
    axis1.cursorTooltipEnabled = false;

    axis1.renderer.maxLabelPosition = 0.98;

    axis1.numberFormatter = new am4core.NumberFormatter();
    axis1.numberFormatter.numberFormat = "$0.###";

    const axis2 = this.chart.yAxes.push(new am4charts.ValueAxis());
    axis2.id = "axis2";
    axis2.title.text = "Quantity";
    axis2.syncWithAxis = axis1;
    axis2.min = 0;
    axis2.cursorTooltipEnabled = false;

    axis2.renderer.opposite = true;

    axis2.renderer.maxLabelPosition = 0.98;

    const series1 = this.chart.series.push(new am4charts.ColumnSeries());
    series1.name = "Earnings (USD)";
    series1.columns.template.strokeOpacity = 0;
    series1.columns.template.fill = am4core.color("#E91E63");

    series1.columns.template.tooltipHTML =
      "<b>{name}</b> for {dateX.formatDate('MMMM YYYY')}<br />${valueY.formatNumber('0.00')}";
    series1.columns.template.tooltipPosition = "pointer";

    series1.dataFields.valueY = "earningsUSD";
    series1.dataFields.dateX = "month";

    series1.sequencedInterpolation = true;
    series1.sequencedInterpolationDelay = 100;

    const series2 = this.chart.series.push(new am4charts.LineSeries());
    series2.name = "Quanity";
    series2.yAxis = axis2;

    const series2Bullets1 = series2.bullets.push(new am4charts.CircleBullet());
    series2Bullets1.tooltipHTML =
      "<b>{name}</b> for {dateX.formatDate('MMMM YYYY')}<br />{valueY}";
    series2Bullets1.fill = am4core.color("#880E4F");

    series2.dataFields.valueY = "quantity";
    series2.dataFields.dateX = "month";

    series2.stroke = am4core.color("#880E4F");
    series2.strokeWidth = 2;

    series2.sequencedInterpolation = true;
    series2.sequencedInterpolationDelay = 100;

    this.chart.legend = new am4charts.Legend();

    // Cursor
    this.chart.cursor = new am4charts.XYCursor();
    this.chart.cursor.behavior = "panX";
    this.chart.cursor.lineX.strokeOpacity = 0;
    this.chart.cursor.lineY.strokeOpacity = 0;
  }

  private formatCurrencyValue(value: number, subCent = false): string {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: subCent ? 4 : 0
    });

    return formatter.format(value);
  }
  private formatNumberValue(value: number): string {
    const formatter = new Intl.NumberFormat("en-US");

    return formatter.format(value);
  }
}
